const FaixaCamposEnum = Object.freeze({
    faixaIdade2: 0,
    faixaIdade3: 1,
    faixaIdade4: 2
})

export default FaixaCamposEnum;
